import reversRetailLogo from "../../assets/icons/reverRetail.svg";
import SpotifyLogo from "../../assets/img/projects/spotistats/spotify.png"
function Projects({ projects, setProjectId }) {
  function defineProjectLogo(project){
    switch(project){
      case "ReversRetail" :
        return reversRetailLogo
      case "Spotify Stats":
        return SpotifyLogo
    }
  }
  return (
    <>
      <div id="presentation" className="mt-12">
        <h2 className="text-2xl font-bold sm:text-3xl mb-6">My projects</h2>
        <p className="opacity-90 my-5 text-lg leading-relaxed">
          During my studies this past year, I completed a tech project that
          aimed to address a specific problem in the industry. Utilizing my
          skills in programming, data analysis and machine learning, I was able
          to develop a system that can predict the chances of success of a
          project by using past data of similar projects. The project received
          positive feedback and was well received by my classmates and
          professors. It was a challenging but rewarding experience, and I'm
          proud of what I was able to accomplish. I believe this project
          showcases my abilities and determination to succeed in the field of
          technology. It was a great opportunity to put into practice the
          knowledge and skills I have acquired throughout my studies and further
          develop them. I am excited to continue to improve and innovate in the
          field of technology.
        </p>
        <div className="grid md:grid-cols-2 sm:grid-cols-1 gap-4">
          {projects &&
            projects.map((project) => (
              <>
                <div
                  className="rounded-lg drop-shadow-xl bg-zinc-800 p-5"
                  id={project.id}
                >
                  <div className="flex items-center space-x-10 pb-5">
                    <img src={defineProjectLogo(project.name)} alt={project.name} width={50} height={50} />
                    <p className="font-bold text-xl uppercase space-line-2">
                      {project.name}
                    </p>
                  </div>
                  <div className="flex flex-col space-x-2">
                    <p>
                      <span className="opacity-70 italic">
                        {project.description}
                      </span>
                    </p>
                    <label htmlFor="my-modal"  className="mt-4 btn text-white" onClick={() => setProjectId(project.id)}>
                        More Informations
                    </label>
                  </div>
                </div>
              </>
            ))}
        </div>
      </div>
    </>
  );
}

export default Projects;
